var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26, _path27, _path28, _path29, _path30, _path31, _path32, _path33, _path34, _path35, _path36, _path37, _path38, _path39, _path40, _path41, _path42, _path43, _path44, _path45, _path46, _path47, _path48, _path49, _path50, _path51, _path52, _path53, _path54, _path55, _path56, _path57, _path58, _path59, _path60, _path61, _path62, _path63, _path64;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgTicketCommon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 60,
    height: 26,
    viewBox: "0 0 60 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59 2H58V1V0H57H56H55H54H53H52H51H50H49H48H47H46H45H44H43H42H41H40H39H38H37H36H35H34H33H32H31H30H29H28H27H26H25H24H23H22H21H20H19H18H17H16H15H14H13H12H11H10H9H8H7H6H5H4H3H2H1H0V1V2H1H2V3V4H1H0V5V6H1H2V7V8H1H0V9V10H1H2V11V12H1H0V13V14H1H2V15V16H1H0V17V18H1H2V19V20H1H0V21V22H1H2V23V24H1H0V25V26H1H2H3H4H5H6H7H8H9H10H11H12H13H14H15H16H17H18H19H20H21H22H23H24H25H26H27H28H29H30H31H32H33H34H35H36H37H38H39H40H41H42H43H44H45H46H47H48H49H50H51H52H53H54H55H56H57H58V25V24H59H60V23V22H59H58V21V20H59H60V19V18H59H58V17V16H59H60V15V14H59H58V13V12H59H60V11V10H59H58V9V8H59H60V7V6H59H58V5V4H59H60V3V2H59ZM56 5V6V7V8V9V10V11V12V13V14V15V16V17V18V19V20V21V22H55V23H54V24H53H52H51H50H49H48H47H46H45H44H43H42H41H40H39H38H37H36H35H34H33H32H31H30H29H28H27H26H25H24H23H22H21H20H19H18H17H16H15H14H13H12H11H10H9H8H7H6V23H5V22H4V21V20V19V18V17V16V15V14V13V12V11V10V9V8V7V6V5V4H5V3H6V2H7H8H9H10H11H12H13H14H15H16H17H18H19H20H21H22H23H24H25H26H27H28H29H30H31H32H33H34H35H36H37H38H39H40H41H42H43H44H45H46H47H48H49H50H51H52H53H54V3H55V4H56V5Z",
    fill: "#8064FF"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M44 6H43V7H44V6Z",
    fill: "#8064FF"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M45 3H44H43H42H41H40H39H38H37H36H35H34H33H32H31H30H29H28H27H26H25H24H23H22H21H20H19H18H17H16H15H14H13V4V5V6V7V8V9V10V11V12V13V14V15V16V17V18V19V20V21V22V23H14H15H16H17H18H19H20H21H22H23H24H25H26H27H28H29H30H31H32H33H34H35H36H37H38H39H40H41H42H43H44H45H46H47V22V21V20V19V18V17V16V15V14V13V12V11V10V9V8V7V6V5V4V3H46H45ZM45 6V7H44V8H45V9V10H44V9V8H43V9V10H42V9V8V7V6V5H43H44H45V6ZM45 17V18V19V20V21H44V20V19V18V17H43V18V19V20V21H42V20V19V18V17V16H43H44H45V17ZM15 20V19V18V17V16H16H17H18V17H17H16V18H17H18V19H17H16V20H17H18V21H17H16H15V20ZM15 9V8V7V6V5H16H17H18V6H17H16V7H17H18V8H17H16V9V10H15V9Z",
    fill: "#8064FF"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M8 23H9H10H11H12V22V21V20V19V18V17V16V15V14V13V12V11V10V9V8V7V6V5V4V3H11H10H9H8H7H6V4H5V5V6V7V8V9V10V11V12V13V14V15V16V17V18V19V20V21V22H6V23H7H8Z",
    fill: "#8064FF"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M55 20V19V18V17V16V15V14V13V12V11V10V9V8V7V6V5V4H54V3H53H52H51H50H49H48V4V5V6V7V8V9V10V11V12V13V14V15V16V17V18V19V20V21V22V23H49H50H51H52H53H54V22H55V21V20Z",
    fill: "#8064FF"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6 3H5V4H6V3Z",
    fill: "#5D24BF"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M55 4V5V6V7V8V9V10V11V12V13V14V15V16V17V18V19V20V21V22H56V21V20V19V18V17V16V15V14V13V12V11V10V9V8V7V6V5V4H55Z",
    fill: "#5D24BF"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M55 3H54V4H55V3Z",
    fill: "#5D24BF"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M52 23H51H50H49H48V22V21V20V19V18V17V16V15V14V13V12V11V10V9V8V7V6V5V4V3H49H50H51H52H53H54V2H53H52H51H50H49H48H47H46H45H44H43H42H41H40H39H38H37H36H35H34H33H32H31H30H29H28H27H26H25H24H23H22H21H20H19H18H17H16H15H14H13H12H11H10H9H8H7H6V3H7H8H9H10H11H12V4V5V6V7V8V9V10V11V12V13V14V15V16V17V18V19V20V21V22V23H11H10H9H8H7H6V24H7H8H9H10H11H12H13H14H15H16H17H18H19H20H21H22H23H24H25H26H27H28H29H30H31H32H33H34H35H36H37H38H39H40H41H42H43H44H45H46H47H48H49H50H51H52H53H54V23H53H52ZM46 23H45H44H43H42H41H40H39H38H37H36H35H34H33H32H31H30H29H28H27H26H25H24H23H22H21H20H19H18H17H16H15H14H13V22V21V20V19V18V17V16V15V14V13V12V11V10V9V8V7V6V5V4V3H14H15H16H17H18H19H20H21H22H23H24H25H26H27H28H29H30H31H32H33H34H35H36H37H38H39H40H41H42H43H44H45H46H47V4V5V6V7V8V9V10V11V12V13V14V15V16V17V18V19V20V21V22V23H46Z",
    fill: "#5D24BF"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M5 20V19V18V17V16V15V14V13V12V11V10V9V8V7V6V5V4H4V5V6V7V8V9V10V11V12V13V14V15V16V17V18V19V20V21V22H5V21V20Z",
    fill: "#5D24BF"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M6 22H5V23H6V22Z",
    fill: "#5D24BF"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M55 22H54V23H55V22Z",
    fill: "#5D24BF"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M16 5H15V6V7V8V9V10H16V9V8H17H18V7H17H16V6H17H18V5H17H16Z",
    fill: "#5D24BF"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M43 5H42V6V7V8V9V10H43V9V8H44V7H43V6H44V7H45V6V5H44H43Z",
    fill: "#5D24BF"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M44 10H45V9V8H44V9V10Z",
    fill: "#5D24BF"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M16 16H15V17V18V19V20V21H16H17H18V20H17H16V19H17H18V18H17H16V17H17H18V16H17H16Z",
    fill: "#5D24BF"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M43 16H42V17V18V19V20V21H43V20V19V18V17H44V18V19V20V21H45V20V19V18V17V16H44H43Z",
    fill: "#5D24BF"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M8 12.5H9H10H11V11.5V10.5V9.5H10H9H8H7H6V10.5V11.5V12.5H7H8ZM7 10.5H8H9H10V11.5H9H8H7V10.5Z",
    fill: "#5D24BF"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M8 16.5H9V15.5V14.5H10V15.5V16.5H11V15.5V14.5V13.5H10H9H8V14.5V15.5H7V14.5V13.5H6V14.5V15.5V16.5H7H8Z",
    fill: "#5D24BF"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M52 9.5H51H50H49V10.5V11.5V12.5H50H51H52H53H54V11.5V10.5V9.5H53H52ZM53 11.5H52H51H50V10.5H51H52H53V11.5Z",
    fill: "#5D24BF"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M52 13.5H51V14.5V15.5H50V14.5V13.5H49V14.5V15.5V16.5H50H51H52V15.5V14.5H53V15.5V16.5H54V15.5V14.5V13.5H53H52Z",
    fill: "#5D24BF"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M29 11H28V12H29V11Z",
    fill: "white"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M30 10H29V11H30V10Z",
    fill: "white"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M32 9H31V10H32V9Z",
    fill: "#B135FF"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M32 10V11H31V12H30H29V13H28H27V14H28H29H30H31V13H32V12H33V11V10H32Z",
    fill: "#B135FF"
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M27 12H26V13H27V12Z",
    fill: "#B135FF"
  })), _path27 || (_path27 = /*#__PURE__*/React.createElement("path", {
    d: "M27 11H26V12H27V11Z",
    fill: "#CB5BFF"
  })), _path28 || (_path28 = /*#__PURE__*/React.createElement("path", {
    d: "M28 12H27V13H28V12Z",
    fill: "#CB5BFF"
  })), _path29 || (_path29 = /*#__PURE__*/React.createElement("path", {
    d: "M31 9H30V10H31V9Z",
    fill: "#CB5BFF"
  })), _path30 || (_path30 = /*#__PURE__*/React.createElement("path", {
    d: "M32 10H31V11H32V10Z",
    fill: "#CB5BFF"
  })), _path31 || (_path31 = /*#__PURE__*/React.createElement("path", {
    d: "M34 10H33V11H34V10Z",
    fill: "#CB5BFF"
  })), _path32 || (_path32 = /*#__PURE__*/React.createElement("path", {
    d: "M35 11H34V12H35V11Z",
    fill: "#CB5BFF"
  })), _path33 || (_path33 = /*#__PURE__*/React.createElement("path", {
    d: "M29 11V12H30H31V11H30H29Z",
    fill: "#CB5BFF"
  })), _path34 || (_path34 = /*#__PURE__*/React.createElement("path", {
    d: "M28 14H27V15H28H29V14H28Z",
    fill: "#CB5BFF"
  })), _path35 || (_path35 = /*#__PURE__*/React.createElement("path", {
    d: "M29 15V16H30H31V15H30H29Z",
    fill: "#CB5BFF"
  })), _path36 || (_path36 = /*#__PURE__*/React.createElement("path", {
    d: "M27 10V11V12H28V11H29V10H28H27Z",
    fill: "#F37AFF"
  })), _path37 || (_path37 = /*#__PURE__*/React.createElement("path", {
    d: "M30 9H29V10H30V9Z",
    fill: "#F37AFF"
  })), _path38 || (_path38 = /*#__PURE__*/React.createElement("path", {
    d: "M35 12H34V13H35V12Z",
    fill: "#F37AFF"
  })), _path39 || (_path39 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15H31V16H32V15Z",
    fill: "#F37AFF"
  })), _path40 || (_path40 = /*#__PURE__*/React.createElement("path", {
    d: "M33 14H32V15H33V14Z",
    fill: "#F37AFF"
  })), _path41 || (_path41 = /*#__PURE__*/React.createElement("path", {
    d: "M31 10H30V11H31V10Z",
    fill: "#FFC9FF"
  })), _path42 || (_path42 = /*#__PURE__*/React.createElement("path", {
    d: "M29 12H28V13H29V12Z",
    fill: "#FFC9FF"
  })), _path43 || (_path43 = /*#__PURE__*/React.createElement("path", {
    d: "M34 14H33V15H34V14Z",
    fill: "#FFC9FF"
  })), _path44 || (_path44 = /*#__PURE__*/React.createElement("path", {
    d: "M35 13H34V14H35V13Z",
    fill: "#FFC9FF"
  })), _path45 || (_path45 = /*#__PURE__*/React.createElement("path", {
    d: "M30 16V17H31H32V16H31H30Z",
    fill: "#3A2B77"
  })), _path46 || (_path46 = /*#__PURE__*/React.createElement("path", {
    d: "M32 15V16H33H34V15H33H32Z",
    fill: "#3A2B77"
  })), _path47 || (_path47 = /*#__PURE__*/React.createElement("path", {
    d: "M35 14H34V15H35V14Z",
    fill: "#3A2B77"
  })), _path48 || (_path48 = /*#__PURE__*/React.createElement("path", {
    d: "M35 12V13V14H36V13V12H35Z",
    fill: "#3A2B77"
  })), _path49 || (_path49 = /*#__PURE__*/React.createElement("path", {
    d: "M27 14H26V15H27V14Z",
    fill: "#47289B"
  })), _path50 || (_path50 = /*#__PURE__*/React.createElement("path", {
    d: "M28 15H27V16H28H29V15H28Z",
    fill: "#47289B"
  })), _path51 || (_path51 = /*#__PURE__*/React.createElement("path", {
    d: "M30 16H29V17H30V16Z",
    fill: "#47289B"
  })), _path52 || (_path52 = /*#__PURE__*/React.createElement("path", {
    d: "M36 11H35V12H36V11Z",
    fill: "#47289B"
  })), _path53 || (_path53 = /*#__PURE__*/React.createElement("path", {
    d: "M35 10H34V11H35V10Z",
    fill: "#47289B"
  })), _path54 || (_path54 = /*#__PURE__*/React.createElement("path", {
    d: "M30 14V15H31H32V14H31H30Z",
    fill: "#47289B"
  })), _path55 || (_path55 = /*#__PURE__*/React.createElement("path", {
    d: "M33 13V14H34V13V12H33V13Z",
    fill: "#47289B"
  })), _path56 || (_path56 = /*#__PURE__*/React.createElement("path", {
    d: "M27 13H26V14H27V13Z",
    fill: "#6F16E2"
  })), _path57 || (_path57 = /*#__PURE__*/React.createElement("path", {
    d: "M34 11H33V12H34V11Z",
    fill: "#6F16E2"
  })), _path58 || (_path58 = /*#__PURE__*/React.createElement("path", {
    d: "M32 13H31V14H32H33V13V12H32V13Z",
    fill: "#6F16E2"
  })), _path59 || (_path59 = /*#__PURE__*/React.createElement("path", {
    d: "M31 8H30H29V9H30H31H32V8H31Z",
    fill: "#5D24BF"
  })), _path60 || (_path60 = /*#__PURE__*/React.createElement("path", {
    d: "M25 12V13V14H26V13V12V11H25V12Z",
    fill: "#5D24BF"
  })), _path61 || (_path61 = /*#__PURE__*/React.createElement("path", {
    d: "M33 9H32V10H33H34V9H33Z",
    fill: "#5D24BF"
  })), _path62 || (_path62 = /*#__PURE__*/React.createElement("path", {
    d: "M30 14H29V15H30V14Z",
    fill: "#5D24BF"
  })), _path63 || (_path63 = /*#__PURE__*/React.createElement("path", {
    d: "M27 9V10H28H29V9H28H27Z",
    fill: "#5D24BF"
  })), _path64 || (_path64 = /*#__PURE__*/React.createElement("path", {
    d: "M27 10H26V11H27V10Z",
    fill: "#5D24BF"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgTicketCommon);
export default __webpack_public_path__ + "static/media/ticket-common.9d257da53bca2b4d490d2eb9d12339da.svg";
export { ForwardRef as ReactComponent };